/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取用户登录日志信息列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetMemberLoginLogParams {
  constructor(public userId: string) {}
}

export default async function (
  params: GetMemberLoginLogParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.MemberLoginLogResponse>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/member-login-log/list`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
